import "./tenant.scss";
import { Modal, Button, Form, Message, Popup, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-skeleton-loader";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


// Custom Functions
import { emailValidate } from "../../lib/emailValidation";
import { expirationSession } from "../../lib/expirationSession";
import {
  secretKeyStatus,
  formatExpiration,
  toDateOnly,
  toApiDate,
  toDisplayDate,
  fromDisplayDate,
  maskDisplayDate,
} from "../../lib/secretKeyStatus";
import { tenantMode } from "../../lib/tenantMode";

// API
import {
  Summary as API_Summary,
  Tenant as API_Tenant,
  SaveTenant as API_SaveTenant,
  Balanced as API_Balanced,
  SaveBalanced as API_SaveBalanced,
  ClientSecretExpiration as API_ClientSecretExpiration,
  SaveClientSecretExpiration as API_SaveClientSecretExpiration,
} from "../../api/tenant";
import { ZimletToken as API_ZimletToken } from "../../api/zimlet";

// Components
import Loading from "../../components/shared/LoadingScreen";
import KeyStatusBadge from "../../components/shared/KeyStatusBadge";
import ServiceStatusBadge from "../../components/shared/ServiceStatusBadge";

// Redux
import { connect } from "react-redux";
import { SetUsername, SetToken, SetPortalMessage } from "../../redux/global/actions";
import {
  SetTenantDetails,
  SetBalancedDetails,
  SetModeDetails,
  SetModal,
  SetZimletToken,
  SetFormMessage,
  SetSecretExpiration
} from "../../redux/tenant/actions";

// -----------------------------------------------------

function Tenant(props) {
  const navigation = useNavigate();
  const { t } = useTranslation();

  // Bozza locale della data di scadenza in formato dd/mm/yyyy,
  // modificata nel modale dedicato (il campo puo' restare vuoto)
  const [expirationDraft, setExpirationDraft] = useState("");

  // API error
  const fncAPIGetError = (error) => {
    if (error.response === undefined || null) {
      props.SetPortalMessage({
        error: true,
        content: t("PortalMessages.Error.Server") + " (500).",
      });
    } else if (error.response.status === 401) {
      expirationSession(props, t, navigation);
    } else {
      props.SetPortalMessage({
        error: true,
        content: t("PortalMessages.Error.Server") + " (" + error.response.status + ").",
      });
    }
  };
  // ---------

  // Email Rooms
  var fncEmailRooms = () => {
    let rows = [];
    props.tenant.balancedDetails.rooms.forEach((element, index) => {
      rows.push(
        <div className="tp_email_rooms" key={index}>
          <p>{element}</p>
          <Button
            icon="trash"
            circular
            onClick={() => {
              if (props.tenant.balancedDetails.rooms.length > 1) {
                props.SetBalancedDetails({
                  rooms: [].concat(
                    props.tenant.balancedDetails.rooms.slice(0, index),
                    props.tenant.balancedDetails.rooms.slice(index + 1)
                  ),
                });
                props.SetFormMessage(null);
              } else {
                props.SetFormMessage(t("PortalMessages.Error.EmailRooms"));
              }
            }}
          />
        </div>
      );
    });
    return rows;
  };
  // ---------


  // -------------------------------

  const fncUpdateGrid = () => {
    API_Tenant(props.global.username, props.global.token)
      .then((body) => {
        props.SetTenantDetails(body.data);
      })
      .catch((error) => {
        fncAPIGetError(error);
      });

    API_Summary(props.global.username, props.global.token)
      .then((body) => {
        props.SetModeDetails(body.data);
      })
      .catch((error) => {
        fncAPIGetError(error);
      });

    API_Balanced(props.global.username, props.global.token)
      .then((body) => {
        props.SetBalancedDetails(body.data);
      })
      .catch((error) => {
        fncAPIGetError(error);
      });

  API_ZimletToken(props.global.username, props.global.token)
    .then((body) => {
      props.SetZimletToken(body.data);
    })
    .catch((error) => {
      fncAPIGetError(error);
    });

    API_ClientSecretExpiration(props.global.username, props.global.token)
      .then((body) => {
        props.SetSecretExpiration(toDateOnly(body.data.client_secret_expiration));
      })
      .catch((error) => {
        fncAPIGetError(error);
      });
  }




  const fncSaveTenant = () => {
    API_SaveTenant(
      props.global.username,
      props.global.token,
      props.tenant.tenantDetails.microsoft_tenant_id,
      props.tenant.tenantDetails.microsoft_client_id,
      props.tenant.tenantDetails.microsoft_client_secret
    )
      .then(() => {
        props.SetPortalMessage({
          error: false,
          content: t("Actions.Saved"),
        });
        fncUpdateGrid();
        props.SetFormMessage(null);
        props.SetModal({ open: false, type: "" });
      })
      .catch((error) => {
        if (error.response === undefined || null) {
          props.SetFormMessage(t("PortalMessages.Error.Server") + " (500).");
        } else if (error.response.status === 401) {
          expirationSession(props, t, navigation);
        } else {
          props.SetFormMessage(t("PortalMessages.Error.KeysNotValid"));
        }
      });
  };

  // Salva la data in bozza; se il campo e' vuoto invia null (scadenza rimossa)
  const fncSaveExpiration = () => {
    var iso = fromDisplayDate(expirationDraft);
    API_SaveClientSecretExpiration(
      props.global.username,
      props.global.token,
      toApiDate(iso)
    )
      .then(() => {
        props.SetPortalMessage({
          error: false,
          content: t("Actions.Saved"),
        });
        props.SetSecretExpiration(toDateOnly(iso));
        props.SetFormMessage(null);
        props.SetModal({ open: false, type: "" });
      })
      .catch((error) => {
        if (error.response === undefined || null) {
          props.SetFormMessage(t("PortalMessages.Error.Server") + " (500).");
        } else if (error.response.status === 401) {
          expirationSession(props, t, navigation);
        } else {
          props.SetFormMessage(
            t("PortalMessages.Error.Server") + " (" + error.response.status + ")."
          );
        }
      });
  };

  const fncSaveBalanced = () => {
    API_SaveBalanced(
      props.global.username,
      props.global.token,
      props.tenant.balancedDetails.rooms
    )
      .then(() => {
        props.SetPortalMessage({
          error: false,
          content: t("Actions.Saved"),
        });
        fncUpdateGrid();
        props.SetFormMessage(null);
        props.SetModal({ open: false, type: "" });
      })
      .catch((error) => {
        if (error.response === undefined || null) {
          props.SetFormMessage(t("PortalMessages.Error.Server") + " (500).");
        } else if (error.response.status === 401) {
          expirationSession(props, t, navigation);
        } else {
          props.SetFormMessage(t("PortalMessages.Error."));
        }
      });
  };
  // ---------

  useEffect(() => {
    fncUpdateGrid();
  }, []);

  // Allinea la bozza al valore salvato ogni volta che il modale viene aperto
  useEffect(() => {
    if (props.tenant.modal.open === true && props.tenant.modal.type === 3) {
      setExpirationDraft(toDisplayDate(props.tenant.secretExpiration));
    }
  }, [props.tenant.modal.open, props.tenant.modal.type, props.tenant.secretExpiration]);

  // Modalita' del tenant: Balanced oppure Direct, mai entrambe
  const fncTenantMode = () => tenantMode(props.tenant.modeDetails);

  // Stato della data in modifica nel modale dedicato
  const draftKeyStatus = secretKeyStatus(fromDisplayDate(expirationDraft));
  // Campo compilato ma non ancora una data valida
  const draftInvalid =
    expirationDraft !== "" && fromDisplayDate(expirationDraft) === "";


  const fncKeyStatusHint = () => {
    if (draftInvalid) {
      return (
        <span className="tp_field_error">
          {t("Tenant.KeyExpirationInvalid")}
        </span>
      );
    }
    if (draftKeyStatus.status === "expired") {
      return (
        <span className="tp_field_error">
          {t("Tenant.KeyExpirationExpired")}
        </span>
      );
    }
    if (draftKeyStatus.status === "warning") {
      return (
        <span className="tp_field_warning">
          {draftKeyStatus.days === 0
            ? t("Tenant.KeyExpirationToday")
            : t("Tenant.KeyExpirationWarning", { days: draftKeyStatus.days })}
        </span>
      );
    }
    return null;
  };

  // -------------------------------------------------------------------

  if (props.tenant === undefined || props.tenant === null) {
    return <Loading />;
  } else {
    return (
      <>
      <div id="tp_card_ctr">
          <div className="tp_card" id="tp_card_colored">
              <div className="tp_card_hr">
                <div>
                  <p>{t("Tenant.TenantCard.TenantDetail")}</p>
                  <Button
                    icon='pencil'
                    circular
                    onClick={() => {
                      props.SetModal({ open: true, type: 1 });
                    }}
                    size="medium"
                  />
                </div>
                <div className="tp_card_description_colored">
                  <p>{t("Tenant.TenantCard.Description")}</p>
                </div>
              </div>
              <div className="tp_card_mn" id="tp_card_mn_colored">
                <div className="tp_card_info tp_card_info_colored">
                  <p>{t("Tenant.TenantCard.Domain")}</p>
                  <span>
                    {props.tenant.tenantDetails.domain === null ? (
                      <Skeleton
                        color="var(--tp_skeleton_color)"
                        width="50px"
                        widthRandomness="0"
                      />
                    ) : (
                      props.tenant.tenantDetails.domain
                    )}
                  </span>
                </div>
                <div className="tp_card_info tp_card_info_colored">
                  <p>{t("Tenant.TenantCard.TenantId")}</p>
                  <span>**********</span>
                </div>
                <div className="tp_card_info tp_card_info_colored">
                  <p>{t("Tenant.TenantCard.ClientId")}</p>
                  <span>**********</span>
                </div>
                <div className="tp_card_info tp_card_info_colored">
                  <p>{t("Tenant.TenantCard.ClientSecret")}</p>
                  <span>**********</span>
                </div>
                {/* Scadenza e stato sono sotto-voci della Client Secret */}
                <div className="tp_card_subinfo">
                  <div className="tp_card_info tp_card_info_colored">
                    <p>{t("Tenant.TenantCard.Expiration")}</p>
                    {props.tenant.secretExpiration === null ? (
                      <Skeleton
                        color="var(--tp_skeleton_color)"
                        width="50px"
                        widthRandomness="0"
                      />
                    ) : (
                      <button
                        type="button"
                        className="tp_badge_edit"
                        title={t("Tenant.EditKeyExpiration")}
                        onClick={() => {
                          props.SetModal({ open: true, type: 3 });
                        }}
                      >
                        <span>
                          {props.tenant.secretExpiration === ""
                            ? t("Status.NoExpiration")
                            : formatExpiration(props.tenant.secretExpiration)}
                        </span>
                        <Icon name="pencil" fitted />
                      </button>
                    )}
                  </div>
                  <div className="tp_card_info tp_card_info_colored">
                    <p>{t("Status.Status")}</p>
                    <KeyStatusBadge
                      expiration={props.tenant.secretExpiration}
                      onEdit={() => props.SetModal({ open: true, type: 3 })}
                    />
                  </div>
                </div>
              </div>
            </div>
            
            <div className="tp_card">
              <div className="tp_card_hr">
                <div>
                  <p>{t("Tenant.ModeStatusCard.ModeStatus")}</p>
                  {
                    props.tenant.modeDetails.balanced_licenses === true ? (
                      <Button
                      icon='pencil'
                      circular
                      onClick={() => {
                        props.SetModal({ open: true, type: 2 });
                      }}
                      size="medium"
                    />
                    ) : null
                  }
                </div>
                <div className="tp_card_description">
                  <p>{t("Tenant.ModeStatusCard.Description")}</p>
                </div>
              </div>
              <div className="tp_card_mn">
                <div className="tp_card_info">
                  <p>{t("Tenant.ModeStatusCard.Mode")}</p>
                  {fncTenantMode() === null ? (
                    <Skeleton
                      color="var(--tp_skeleton_color)"
                      width="50px"
                      widthRandomness="0"
                    />
                  ) : fncTenantMode() === "none" ? (
                    <p className="tp_card_status_unactive">
                      {t("Tenant.ModeStatusCard.NoMode")}
                    </p>
                  ) : (
                    <p className="tp_card_status_active">
                      {fncTenantMode() === "direct"
                        ? t("Tenant.ModeStatusCard.Direct")
                        : t("Tenant.ModeStatusCard.Balanced")}
                    </p>
                  )}
                </div>
                <div className="tp_card_info">
                  <p>{t("Tenant.ModeStatusCard.Service")}</p>
                  {fncTenantMode() === null ? (
                    <Skeleton
                      color="var(--tp_skeleton_color)"
                      width="50px"
                      widthRandomness="0"
                    />
                  ) : fncTenantMode() === "none" ? (
                    <p className="tp_card_status_unactive">
                      {t("Status.UnActive")}
                    </p>
                  ) : (
                    <ServiceStatusBadge
                      username={props.global.username}
                      token={props.global.token}
                      mode={fncTenantMode()}
                      onAuthError={() => expirationSession(props, t, navigation)}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="tp_card">
              <div className="tp_card_hr">
                <div>
                <p>{t("Tenant.ZimetCard.Zimlet")}</p>
                </div>
                <div className="tp_card_description">
                  <p>{t("Tenant.ZimetCard.Description")}</p>
                </div>
              </div>
              <div className="tp_card_mn">
                <div className="tp_card_info">
                  <p>{t("Tenant.ZimetCard.Token")}</p>
                  {props.tenant.zimletKeys.admin_zimlet_customer_token === null ? (
                    <Skeleton
                      color="var(--tp_skeleton_color)"
                      width="50px"
                      widthRandomness="0"
                    />
                  ) :
                  <Popup
                  content={t("Input.Copy")}
                  on="click"
                  pinned
                  trigger={
                    <span style={{textDecoration:"underline",cursor:"pointer"}} onClick={() => {navigator.clipboard.writeText(props.tenant.zimletKeys.admin_zimlet_customer_token)}}>
                    {props.tenant.zimletKeys.admin_zimlet_customer_token.length > 20? props.tenant.zimletKeys.admin_zimlet_customer_token.slice(0,20) + '...' : props.tenant.zimletKeys.admin_zimlet_customer_token}
                  </span>  
                  }
                />
                  }
                </div>
                <div className="tp_card_info">
                  <p>{t("Tenant.ZimetCard.Secret")}</p>
                  {props.tenant.zimletKeys.admin_zimlet_customer_secret === null ? (
                    <Skeleton
                      color="var(--tp_skeleton_color)"
                      width="50px"
                      widthRandomness="0"
                    />
                  ) :
                  <Popup
                  content={t("Input.Copy")}
                  on="click"
                  pinned
                  trigger={
                    <span style={{textDecoration:"underline",cursor:"pointer"}} onClick={() => {navigator.clipboard.writeText(props.tenant.zimletKeys.admin_zimlet_customer_secret)}}>
                    {props.tenant.zimletKeys.admin_zimlet_customer_secret.length > 20? props.tenant.zimletKeys.admin_zimlet_customer_secret.slice(0,20) + '...' : props.tenant.zimletKeys.admin_zimlet_customer_secret}
                  </span> 
                  }
                />
                  }
                </div>
              </div>
            </div>
          </div>
          
        <Modal
          onClose={() =>
            props.SetModal(Object.assign(props.tenant.modal, { open: false }))
          }
          open={props.tenant.modal.open}
        >
          {props.tenant.modal.type === 1 ? (
            <>
              <Modal.Header>
                {t("Tenant.EditTenant")}
              </Modal.Header>
              <Modal.Content>
              {props.tenant.formMessage !== null ? (
              <Message error content={props.tenant.formMessage} />
            ) : null}
                <Form onChange={()=>SetFormMessage(null)}>
                  <div className="tp_disabled">
                    <strong>{t("Tenant.TenantCard.Domain")}</strong>
                    <p>{props.tenant.tenantDetails.domain}</p>
                  </div>
                  <Form.Input
                    label={t("Tenant.TenantCard.TenantId")}
                    defaultValue={
                      props.tenant.tenantDetails.microsoft_tenant_id
                    }
                    required
                    onChange={(e, d) =>
                      props.SetTenantDetails(
                        Object.assign(props.tenant.tenantDetails, {
                          microsoft_tenant_id: d.value,
                        })
                      )
                    }
                  />
                  <Form.Input
                    label={t("Tenant.TenantCard.ClientId")}
                    defaultValue={
                      props.tenant.tenantDetails.microsoft_client_id
                    }
                    required
                    onChange={(e, d) =>
                      props.SetTenantDetails(
                        Object.assign(props.tenant.tenantDetails, {
                          microsoft_client_id: d.value,
                        })
                      )
                    }
                  />
                  <Form.Input
                    label={t("Tenant.TenantCard.ClientSecret")}
                    defaultValue={
                      props.tenant.tenantDetails.microsoft_client_secret
                    }
                    required
                    onChange={(e, d) =>
                      props.SetTenantDetails(
                        Object.assign(props.tenant.tenantDetails, {
                          microsoft_client_secret: d.value,
                        })
                      )
                    }
                  />
                </Form>
              </Modal.Content>
              <Modal.Actions>
                <Button
                  content={t("Button.Cancel")}
                  onClick={() => {
                    props.SetModal({ open: false, type: "" });
                    props.SetFormMessage(null);
                  }}
                />
                <Button
                  content={t("Button.Save")}
                  className="tp_btn"
                  onClick={() => {
                    // props.tenant.tenantDetails expiration_key
                    if (
                      props.tenant.tenantDetails.microsoft_tenant_id &&
                      props.tenant.tenantDetails.microsoft_client_id &&
                      props.tenant.tenantDetails.microsoft_client_secret
                    ) {
                      fncSaveTenant();
                    } else {
                      props.SetFormMessage(t("PortalMessages.Error.FieldsEmpty"));
                    }
                  }}
                />
              </Modal.Actions>
            </>
          ) : props.tenant.modal.type === 3 ? (
            <>
              <Modal.Header>
                {t("Tenant.EditKeyExpiration")}
              </Modal.Header>
              <Modal.Content>
                {props.tenant.formMessage !== null ? (
                  <Message error content={props.tenant.formMessage} />
                ) : null}
                <Message info content={t("Tenant.KeyExpirationMessage")} />
                <Form>
                  <Form.Input
                    type="text"
                    inputMode="numeric"
                    maxLength={10}
                    placeholder={t("Tenant.KeyExpirationPlaceholder")}
                    label={t("Tenant.TenantCard.KeyExpiration")}
                    value={expirationDraft}
                    error={draftInvalid || draftKeyStatus.status === "expired"}
                    action={{
                      icon: "eraser",
                      type: "button",
                      title: t("Button.Clear"),
                      disabled: expirationDraft === "",
                      onClick: () => {
                        setExpirationDraft("");
                        props.SetFormMessage(null);
                      },
                    }}
                    onChange={(e, d) => {
                      setExpirationDraft(maskDisplayDate(d.value));
                      props.SetFormMessage(null);
                    }}
                  />
                  {fncKeyStatusHint()}
                </Form>
              </Modal.Content>
              <Modal.Actions>
                <Button
                  content={t("Button.Cancel")}
                  onClick={() => {
                    props.SetModal({ open: false, type: "" });
                    props.SetFormMessage(null);
                  }}
                />
                <Button
                  content={t("Button.Save")}
                  className="tp_btn"
                  disabled={draftInvalid}
                  onClick={() => {
                    fncSaveExpiration();
                  }}
                />
              </Modal.Actions>
            </>
          ) : (
            <>
              <Modal.Header>
                {t("Tenant.EditBalancedMode")}
              </Modal.Header>
              <Modal.Content>
              {props.tenant.formMessage !== null ? (
              <Message error content={props.tenant.formMessage} />
            ) : null}
                <Message info content={t("Tenant.Message")} />
                <Form onChange={()=>SetFormMessage(null)}>
                  <div id="tp_add_mail_rooms">
                    <Form.Input
                      label={ 'Microsoft Teams Account' + ' (' + props.tenant.modeDetails.balanced_rooms_count + ')'}
                      id="balanced_room_value"
                    />
                    <Form.Button
                      icon="plus"
                      circular
                      onClick={() => {
                        var room = document.querySelector("#balanced_room_value").value.trim();
                        if (room) {
                          if (emailValidate(room)) {
                            if (props.tenant.balancedDetails.rooms.indexOf(room) === -1) {
                              let copy =
                                props.tenant.balancedDetails.rooms.splice(0);
                              copy.push(room);
                              props.SetBalancedDetails({ rooms: copy });
                              props.SetFormMessage(null);
                              document.querySelector("#balanced_room_value").value = "";
                            } else {
                              props.SetFormMessage(t("PortalMessages.Error.EmailExist"));
                            }
                           
                          } else {
                            props.SetFormMessage(t("PortalMessages.Error.MailNotValid"));
                          }
                        } else {
                          props.SetFormMessage(t("PortalMessages.Error.FieldsEmpty"));
                        }
                      }}
                    />
                  </div>
                  <div id="tp_email_rooms_ctr">{fncEmailRooms()}</div>
                </Form>
              </Modal.Content>
              <Modal.Actions>
                <Button
                  content={t("Button.Cancel")}
                  onClick={() => {
                    props.SetModal({ open: false, type: "" });
                    props.SetFormMessage(null);
                  }}
                />
                <Button
                  content={t("Button.Save")}
                  className="tp_btn"
                  onClick={() => {
                    fncSaveBalanced();
                  }}
                />
              </Modal.Actions>
            </>
          )}
        </Modal>
      </>
    );
  }
}

// -----------------------------------------------------

// Mapping Hook
function mapStateToProps(state) {
  return { global: state.global, tenant: state.tenant };
}

const mapDispatchToProps = (dispatch) => {
  return {
    SetUsername: (value) => dispatch(SetUsername(value)),
    SetToken: (value) => dispatch(SetToken(value)),
    SetPortalMessage: (value) => dispatch(SetPortalMessage(value)),

    SetTenantDetails: (value) => dispatch(SetTenantDetails(value)),
    SetBalancedDetails: (value) => dispatch(SetBalancedDetails(value)),
    SetModeDetails: (value) => dispatch(SetModeDetails(value)),
    SetModal: (value) => dispatch(SetModal(value)),
    SetZimletToken: (value) => dispatch(SetZimletToken(value)),
    SetFormMessage: (value) => dispatch(SetFormMessage(value)),
    SetSecretExpiration: (value) => dispatch(SetSecretExpiration(value)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Tenant);
